import type { AcademyBadge } from '~/types/academy/baseTraining';

export const BADGE_LABEL_KEYS = {
    eLearning: 'academy.badgeLabel.eLearning',
    inPerson: 'academy.badgeLabel.inPerson',
    liveWebinar: 'academy.badgeLabel.liveWebinar',
    cme: 'academy.badgeLabel.cme',
    completed: 'academy.badgeLabel.completed',
    new: 'academy.badgeLabel.new',
    reminder: 'academy.badgeLabel.reminder'
} as const;

export type BadgeLabelType = keyof typeof BADGE_LABEL_KEYS;

const badgeByTrainingType: Record<string, BadgeLabelType> = {
    'e-learning': 'eLearning',
    elearning: 'eLearning',
    präsenz: 'inPerson',
    'live-webinar': 'liveWebinar',
    cme: 'cme'
};

export function mapTrainingTypeToBadgeType(value: string | null | undefined): BadgeLabelType | null {
    const normalized = value?.trim().toLowerCase();

    if (!normalized) {
        return null;
    }

    const exactMatch = badgeByTrainingType[normalized];

    if (exactMatch) {
        return exactMatch;
    }

    if (normalized.includes('classroom') || normalized.includes('ilt') || normalized.includes('präsenz')) {
        return 'inPerson';
    }

    if (normalized.includes('webinar')) {
        return 'liveWebinar';
    }

    if (normalized.includes('elearning') || normalized.includes('e-learning')) {
        return 'eLearning';
    }

    if (normalized.includes('cme')) {
        return 'cme';
    }

    return null;
}

export function trainingTypeBadge(value: string | null | undefined): AcademyBadge | null {
    const type = mapTrainingTypeToBadgeType(value);

    if (!type) {
        return null;
    }

    return { type, labelKey: BADGE_LABEL_KEYS[type] };
}
